import { render, staticRenderFns } from "./SimpleDataWithVariation.vue?vue&type=template&id=7370cd82&scoped=true&"
import script from "./SimpleDataWithVariation.vue?vue&type=script&lang=js&"
export * from "./SimpleDataWithVariation.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDataWithVariation.vue?vue&type=style&index=0&id=7370cd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370cd82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VDialog})
